import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Data2Service } from '../../../common/data2.service';

@Component({
	selector: 'app-tourism-transport-list-confirmation',
	templateUrl: './tourism-transport-list-confirmation.component.html',
	styleUrls: ['./tourism-transport-list-confirmation.component.css'],
})
export class TourismTransportListConfirmationComponent implements OnInit {
	private readonly itemsBeforeDataLoad = 0;
	loader = true;
	timetableId: number = null;
	data: Array<any> = [];

	constructor(
		private readonly api: Data2Service,
		private readonly route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		if (!this.route.snapshot.params.id) {
			return;
		}
		const transportsOrder = ['ant', 'ant2', 'pl'];
		this.timetableId = this.route.snapshot.params.id;
		this.api.get('/tourismTimetableConfirmations/?timetable=' + this.timetableId, (result, error) => {
			const checked = result.data;
			this.api.get('/tourismTransportLists/' + this.timetableId, (result, error) => {
				result.data.forEach((obj) => {
					const isChecked = checked.find(
						(findObj) =>
							findObj.uncheckedBy == null &&
							findObj.reservation == obj.businessCaseNumber &&
							findObj.personId == obj.businessCasePersonId,
					);
					obj.saveStatus = isChecked ? 1 : 0;
				});
				this.data = result.data;
				this.loader = false;
			});
		});
	}

	confirm(row) {
		row.saveStatus = 2;
		const data = {
			timetable: this.timetableId,
			reservation: row.businessCaseNumber,
			personId: row.businessCasePersonId,
		};
		this.api.post('/tourismTimetableConfirmations/', data, (result, error) => {
			if (error) {
				return;
			}
			row.saveStatus = 1;
		});
	}

	unconfirm(row) {
		row.saveStatus = 2;
		const parms =
			'?timetable=' +
			this.timetableId +
			'&reservation=' +
			row.businessCaseNumber +
			'&personId=' +
			row.businessCasePersonId;
		this.api.del('/tourismTimetableConfirmations/' + parms, (result, error) => {
			if (error) {
				return;
			}
			row.saveStatus = 0;
		});
	}
}
